<template>
  <div class="container">
    <div class="head">
        <div class="title">
          <div class="text">诚信评价基础工作考评</div>
          <div class="branch">-0.3</div>
        </div>
        <div class="tip">
          <div class="con">大理州-大理市</div>
          <div class="con">一类地区</div>
        </div>
        <div class="date">2019-11-01 12:31:22</div>
      </div>
    <div class="pg-pd12">
      <div>
           <causeDeduction  :causeContent="causeContent" />
      </div>
      <!-- 扣分详情 -->
      <detailCom  :infoObj="infoObj"/>
      <!-- 相关材料 -->
      <materialScience :caseList="assessFile" :id="id" />
   </div>
  </div>
</template>
<script>
    // import Vue from 'vue';
    import causeDeduction from './components/causeDeduction';// 扣分原因
    import detailCom from './components/detailCom';// 事故详情
    import materialScience from './components/materialScience';// 相关材料
    import api from '../../service/modules/appraise';
    import { } from 'vant';
    // Vue.use(Picker);
    export default {
        components: {
            causeDeduction, materialScience, detailCom
        },

        data () {
            return {
                id: '1',
                caseList: [
                    { id: '1', title: '文化和旅游', type: 'pdf' },
                    { id: '2', title: '公安一', type: 'doc' },
                    { id: '2', title: '公安一', type: 'exl' }
                ],
                causeContent: '接到游客投诉未在5分钟内响应',
                // 相关材料列表
                assessFile: [
                    { fileName: '文化和旅游', fileType: 'pdf', download_url: 'http://127.0.0.1:8080/swf/project/13769245747/6DAC1564-B88C-EE50-6BF8-5CA316622774/20191018143255_XXXX/20191018143255.pdf' },
                    { fileName: '公安一', fileType: 'doc', download_url: 'http://127.0.0.1:8080/swf/project/13769245747/6DAC1564-B88C-EE50-6BF8-5CA316622774/20191018143255_XXXX/20191018143255.pdf' },
                    { fileName: '公安一', fileType: 'exl', download_url: 'http://127.0.0.1:8080/swf/project/13769245747/6DAC1564-B88C-EE50-6BF8-5CA316622774/20191018143255_XXXX/20191018143255.pdf' }
                ],
                infoObj: {
                    title: '事故详情',
                    content: '按报案时间：2019年11月5日14时25分，出险情况云南省康辉旅行汽车有限公司车辆，在云南省丽江市一停车场内因操作不当，碾压等待上车的游客李某某，造成该游客当成死亡。事故等级为一般事故该事故发生在大理市辖区市一停车场内因操作不当某某，造成该游客当成死亡。事故等级为一般事故该事故发生在大理市辖区市一停车场内因操作不当某某，造成该游客当成死亡。'
                }
            }
        },

        computed: {},

        watch: {},

        methods: {
            // 考核明细接口
            getSubAssessDetail () {
                api.getAssessDetailById({ id: '335C6B06-33CA-D7E4-B539-C35B6B9BA99E', complainId: '201907141721243498431', subType: 'A1' }).then(res => {
                    if (res.ret === 0) {
                        this.assessDetail = res.data.assessDetail
                        this.caseDetail = res.data.assessDetail.caseDetail// 事故详情
                        this.infoObj = {
                            title: '事故详情',
                            content: this.caseDetail
                        }
                    } else {
                        this.$Message.error(res.data.msg)
                    }
                });
            },
            navTo () {
                this.$router.push({
                    path: '/appraise/scoreList'
                })
            }
        },

        mounted () {
        },

        created () {
            this.getSubAssessDetail()
        }

    }
</script>
<style scoped lang="less">
  .container {
    min-height: 100vh;
    background: rgba(251, 251, 251, 1);
    padding-bottom: 24px;
  .pg-pd12 {
      padding-left: 12px;
      padding-right: 12px;

    }
        .head{
          width: 100%;
          background: #fff;
          padding: 24px 12px;
          margin-bottom: 24px;
          .title{
            height:22px;
            line-height: 22px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .text{
              font-size:20px;
              font-family:PingFangSC-Medium,PingFang SC;
              font-weight:500;
              color:rgba(51,51,51,1);
              line-height:20px;
            }
            .branch{
              height:22px;
              font-size:22px;
              font-family:DIN-Medium,DIN;
              font-weight:500;
              color:rgba(255,77,77,1);
              line-height:22px;
            }
        }
        .tip{
          margin-top:12px;
          display: flex;
          font-size:10px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(54,179,116,1);
          .con{
            border:1Px solid rgba(54,179,116,1);
            padding: 2px 4px;
            margin-right:14px;
          }
        }
        .date{
          margin-top:12px;
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(153,153,153,1);
          line-height:12px;
        }
    }
.main{
      margin-top: 24px;
      padding-bottom: 30px;
      .title{
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
      }
      .content{
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
        border-radius:3px;
        margin-top: 12px;
        .ts-list{
          padding: 12px 0;
          text-align: center;
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(155,155,155,1);
          line-height:17px;
          span{
            padding-right: 10px;
            background: url(../../assets/image/t-right.png) no-repeat;
            background-size: 8px 8px;
            background-position: right center;
          }
        }
      }
    }
  }
</style>
